import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=1703b58a&scoped=true"
import script from "./NoPermission.vue?vue&type=script&lang=js"
export * from "./NoPermission.vue?vue&type=script&lang=js"
import style0 from "./NoPermission.vue?vue&type=style&index=0&id=1703b58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703b58a",
  null
  
)

export default component.exports